import React from 'react';
import './Contact.css';
import ContactForm from '../../components/contact/ContactForm.tsx';
import SEO from '../../components/SEO/SEO.tsx';
import StructuredData from '../../components/SEO/StructuredData.tsx';
import photo from '../../assets/images/photo1.png';

const Contact: React.FC = () => {
  return (
    <>
      <SEO 
        title="Contact CABnHAUL - Book Your Luxury Private Transportation"
        description="Book premium luxury transportation with CABnHAUL. Contact us for executive car service, VIP rides, and private transportation. Call (215) 384-3448 or email CabnHaul@gmail.com for personalized service."
        keywords="book luxury transportation, contact private car service, reserve executive transportation, VIP car service booking, luxury taxi reservation, private driver contact, (215) 384-3448"
        url="https://cabnhaul.com/contact"
        type="website"
      />
      <StructuredData type="ContactPage" />
      
      <div className="contact-page">
        <div className="contact-content">
          <div className="contact-layout">
            <div className="contact-form-col">
              <ContactForm />
            </div>

            <aside className="contact-aside" aria-label="Contact options">
              <div
                className="aside-card"
                role="link"
                tabIndex={0}
                onClick={() => (window.location.href = 'mailto:CabnHaul@gmail.com')}
                onKeyDown={(e) => { if (e.key === 'Enter') window.location.href = 'mailto:CabnHaul@gmail.com'; }}
                aria-label="Email CabnHaul@gmail.com"
              >
                <div className="aside-header">
                  <div className="aside-icon" aria-hidden>✉️</div>
                  <div>
                    <h3 className="aside-title">Email Us</h3>
                    <p className="aside-subtext">We typically reply within a few hours.</p>
                  <a className="aside-link" href="mailto:CabnHaul@gmail.com">CabnHaul@gmail.com</a>
                  </div>
                </div>
              </div>

              <div
                className="aside-card"
                role="link"
                tabIndex={0}
                onClick={() => (window.location.href = 'tel:+12153843448')}
                onKeyDown={(e) => { if (e.key === 'Enter') window.location.href = 'tel:+12153843448'; }}
                aria-label="Call (215) 384-3448"
              >
                <div className="aside-header">
                  <div className="aside-icon" aria-hidden>📞</div>
                  <div>
                    <h3 className="aside-title">Call Us</h3>
                    <p className="aside-subtext">Friendly assistance during reasonable hours.</p>
                  <a className="aside-link" href="tel:+12153843448">(215) 384-3448</a>
                  </div>
                </div>
              </div>
              <div className="aside-card aside-photo-card" aria-hidden="true">
                <img
                  src={photo}
                  alt="Luxury private transportation vehicle"
                  className="aside-photo"
                  loading="lazy"
                />
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact; 